import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import _ from "lodash";
// Used by a slew of custom row objects (55 when this comment was added)
// Used by the Leesona 861 Tackified and Wax machines, SSM DP5, DS10-E,
// DS21-31, SSM Duro, Heli (Pirn) KV2002, Leesona M50 and M50 Wax machines,
// Mahan Dryer, Mahan Oven, Ratera, Saco Ring Twister, Sahm 230E, Saurer TC2,
// SSM Kingspool, Taining 35AFP/AR/A Tube/S41 machines, Texilmesa Kingspool,
// UT50/60, SSM Xeno, and Xorella machines

export default function InputRangeRow({
   titleProp,
   descriptionProp = false,
   sizeProp = 4,
   typeProp = "text",
   minProp = 1,
   maxProp = 32767,
   propertyNameProp, //non nullable for value and error div
   errorDialogueProp = "Cannot be left empty",
   floatProp = false,
   readOnlyProp = false,
   string,
   colSizeProp,
}) {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };
   const value = machineSetup.extendedPropertyJson?.[propertyNameProp];
   if (propertyNameProp === undefined) return false;
   return (
      <Row className="mb-2">
         <ColPrompt
            title={titleProp}
            bold={true}
            description={descriptionProp}
            sizeProp={colSizeProp || undefined}
         />
         <ColValue size={sizeProp}>
            <Input
               type={typeProp}
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={_.isNil(value) ? "" : value}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, minProp, maxProp, propertyNameProp, string, floatProp)
                     : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, propertyNameProp)
               }
               readOnly={readOnlyProp}
               disabled={readOnlyProp}
            />
            {errorDivDefinitions?.[propertyNameProp] && (
               <ErrorDiv>{errorDialogueProp}</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}
